import React from "react";
import classnames from "class-names";
import Plx from "react-plx";

class HomepageJumbotron extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
      inited: false,
      slidesOffset: 0
    };

    this.slidesRef = React.createRef();
    this.currentSlideRef = React.createRef();
    this.timer = null;

    this.changeSlide = this.changeSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.resizeHandler = this.resizeHandler.bind(this);
  }

  componentDidMount() {
    // Prevents animation flickering on first load
    // setTimeout(() => this.setState({ inited: true }), 200);

    if (typeof window !== "undefined") {
      this.resetTimer();
      window.addEventListener("resize", this.resizeHandler);
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      clearInterval(this.timer);
      window.removeEventListener("resize", this.resizeHandler);
    }
  }

  resizeHandler() {
    this.changeSlide(this.state.currentSlide);
  }

  changeSlide(currentSlide) {
    this.resetTimer();
    this.setState({ currentSlide });
    this.setState({ slidesOffset: this.calcOffset(currentSlide) });
  }

  calcOffset(index) {
    const position = -1 * index * this.slidesRef.current.getBoundingClientRect().width;
    return 'translate3d(' + position + 'px, 0, 0)'
  }

  nextSlide() {
    const { currentSlide } = this.state;
    const { slides } = this.props;
    this.changeSlide((currentSlide + 1) % slides.length);
  }

  resetTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = setInterval(this.nextSlide, this.props.tick);
  }

  render() {
    const { currentSlide, inited, slidesOffset } = this.state;
    const { slides, background } = this.props;

    return (
      <div className="jumbotron-slider">
        <Plx
          animateWhenNotInViewport
          // parallaxData={[
          //   {
          //     start: "self",
          //     duration: "100vh",
          //     properties: [
          //       {
          //         property: "translateY",
          //         startValue: -0,
          //         endValue: 0
          //       }
          //     ]
          //   }
          // ]}
          className="jumbotron-slider__image"
        >
          <div className="jumbotron-slider__image-element" />
        </Plx>

        <div className="container">
          <div className="jumbotron-slider-slides">
            <div className="jumbotron-slider-inner" ref={this.slidesRef} style={{ transform: slidesOffset }}>
              {slides.map((slide, index) => (
                <div
                  className={classnames("jumbotron-slider__container", {
                    "jumbotron-slider__container_hidden": currentSlide !== index,
                    "jumbotron-slider__container_no-transition": !inited
                  })}
                  ref={currentSlide === index ? this.currentSlideRef : null}
                  key={index}
                >
                  <p
                    className="jumbotron-slider__title"
                    dangerouslySetInnerHTML={{ __html: slide.title }}
                  />
                  <div
                    className="jumbotron-slider__description"
                    dangerouslySetInnerHTML={{ __html: slide.description }}>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="jumbotron-slider__dots">
            {slides.map((_, index) => (
              <div
                className={classnames("jumbotron-slider__dot", {
                  "jumbotron-slider__dot_active": currentSlide === index
                })}
                key={index}
                onClick={() => this.changeSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default HomepageJumbotron;
